import React, { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import paintings from "../galleryData";

function CustomArrow({ direction, onClick }) {
  return (
    <button
      onClick={onClick}
      className={`absolute top-1/2 transform -translate-y-2/3 rounded-full bg-beige/80 hover:bg-beige shadow-md z-10 ${direction === "left" ? "left-4 sm:left-6" : "right-4 sm:right-6"
        }`}
      style={{ height: "40px", width: "40px" }}
    >
      <h1 className="text-brown-600 font-extrabold ">{direction === "left" ? "<" : ">"}</h1>
    </button>
  );
}

function Gallery() {
  const [selectedImage, setSelectedImage] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);


  const settings = {
    className: "slider variable-width",
    infinite: true,
    centerMode: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    arrows: true,
    prevArrow: <CustomArrow direction="left" />,
    nextArrow: <CustomArrow direction="right" />,
    dots: true,
    autoplay: true,
  };

  const openModal = (image) => {
    setSelectedImage(image);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  const handleOverlayClick = (e) => {
    if (e.target.id === "modal-overlay") {
      closeModal();
    }
  };

  return (
    <>
      <div className="lg:pt-16 md:pt-12 pt-8 flex mt-15 justify-center gap-2 md:gap-5 overflow-x-auto max-sm:justify-start max-sm:ps-2" id="galleryNav">  
        {paintings.map((pType, ind) => (
          <button 
            className={`text-nowrap lg:px-3 md:px-2 px-1 py-1 text-brown-600 text-sm md:text-lg font-semibold max-sm:font-normal rounded-lg transition-all shadow-inset font-para ${activeIndex===pType.id-1? "shadow-md bg-beige/50": "hover:bg-beige/50 hover:shadow-md"}`} 
            key={pType.id} 
            onClick={() => setActiveIndex(ind)}
          >
            {pType.type}
          </button>
        ))}
      </div>
      <div className="slider-container relative mt-3 md:mt-5 px-2 md:px-8 overflow-x-hidden pb-8 mb-12">
        <Slider {...settings}>
          {paintings[activeIndex].items.map((painting) => (
            <div
              key={painting.id}
              className="flex-shrink-0 px-2 sm:px-4 cursor-pointer"
              onClick={() => openModal(painting)}
            >
              <img
                src={`/images/gallery/${painting.src}`}
                alt={painting.name}
                className="h-[55vh] max-lg:h-[45vh] max-md:h-[35vh] max-sm:h-[20vh] w-auto object-cover rounded-md hover:transform hover:shadow-lg hover:shadow-gray-500 transition-transform duration-300"
              />
              <div className="mt-2 text-md text-center max-sm:mb-8">
                <p className="font-semibold text-brown-700">{painting.name}</p>
                <p className="text-xs text-brown-600">{painting.size}</p>
                <p className="text-xs text-brown-600">{painting.tag}</p>
              </div>
            </div>
          ))}
        </Slider>

        {/* Modal */}
        {selectedImage && (
          <div
            id="modal-overlay"
            className="fixed inset-0 bg-black bg-opacity-70 flex justify-center items-center z-50"
            onClick={handleOverlayClick}
          >
            <div className="relative bg-slate-200 rounded-lg shadow-lg p-4 max-sm:px-2">
              <button
                onClick={closeModal}
                className="absolute top-2 right-2 bg-beige text-brown-700 font-extrabold rounded-full w-9 h-9 flex items-center justify-center"
              >
                &times;
              </button>
              <img
                src={`/images/gallery/${selectedImage.src}`}
                alt={selectedImage.name}
                className="w-auto max-w-[90vw] h-auto max-h-[80vh] max-sm:max-h-[55vh] object-contain rounded-lg"
              />
              <div className="mt-4 text-center text-brown-600">
                <p className="font-bold text-lg max-sm:text-md">{selectedImage.name}</p>
                <p className="text-sm max-sm:text-xs">{selectedImage.size}</p>
                <p className="text-sm max-sm:text-xs">{selectedImage.tag}</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default Gallery;